<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { _ } from "svelte-i18n";
  import type { ProductOption } from "$lib/gql/gen/codegen";

  export let productOption: ProductOption = {
    id: "",
    name: "",
    values: [],
  };
  export let selected: string = "";

  const dispatch = createEventDispatcher();
  const onChange = data => {
    dispatch("change", data);
  };
  $: onChange(selected);
</script>

<style lang="scss">
  label {
    display: inline;
    font-weight: 500;
    text-transform: capitalize;
  }
  select {
    border: 1px solid $inverse-surface;
  }
</style>

<form>
  <select name={productOption.name} id={productOption.id} bind:value={selected}>
    <option value="" disabled>{$_("Choose an option")}...</option>
    {#each productOption.values as value}
      <option {value}>{value}</option>
    {/each}
  </select>
  <label for={productOption.id}>{productOption.name}</label>
</form>
